export default __webpack_public_path__ + "static/media/services_municipal_1.30ad5383.jpg";